import axios, {CancelTokenSource} from 'axios';
import * as _ from 'lodash';

export class RequestCancellationManager {
  static createCancellationHandlers(key: string) {
    const controller = new AbortController();
    const source = axios.CancelToken.source();
    RequestCancellationManager.updateRequestCancellationManagerState(key, controller, source);

    return {
      cancelToken: source.token,
      signal: controller.signal
    };
  }

  static updateRequestCancellationManagerState(key: string, controller: AbortController, source: CancelTokenSource) {
    if (!key) {
      throw new Error('RequestCancellationManager: action type should be specified');
    }
    if (!window.RequestCancellationManager) {
      window.RequestCancellationManager = {};
    }
    window.RequestCancellationManager[key] = {controller, source};
  }

  static stopRequests(prefix: string) {
    if (window?.RequestCancellationManager) {
      const requests = _.pickBy(window.RequestCancellationManager, (value, key) => key.startsWith(prefix));
      _.forEach(requests, ({controller, source}, key) => {
        if (source) source.cancel('Request cancelled');
        if (controller) controller.abort();
        RequestCancellationManager.forgetRequest(key);
      });
    }
  }

  static forgetRequest(key: string) {
    if (window?.RequestCancellationManager) {
      window.RequestCancellationManager = _.omit(window.RequestCancellationManager, key);
    }
  }
}